import { Button } from '../ui/button';
import { useGlobalStore } from '@/stores/store';
import { UserIcon } from '../ui/user-icon';
import { cn } from '@/lib/utils';
import { useResponsive } from '@/hooks/use-responsive';
import { useShallow } from 'zustand/react/shallow';
import { useLogout } from '@/hooks/use-logout';

export const UserProfileMobile = () => {
  const { isMobile } = useResponsive();
  const { isAuthenticated, loginCredentials, email } = useGlobalStore(
    useShallow((store) => ({
      email: store.authStore.authFlow.email,
      loginCredentials: store.authStore.loginCredentials,
      isAuthenticated: store.authStore.isAuthenticated,
    }))
  );

  const handleLogout = useLogout();

  if (!isAuthenticated || !loginCredentials) {
    return null;
  }

  const { firstName, lastName } = loginCredentials.individual;
  return (
    <div
      className={cn('p-2 pl-3 md:px-5 md:pl-3 md:py-[10px] mt-2 w-full', {})}
    >
      <div className="flex gap-2 mb-4 md:mb-5">
        <UserIcon initial={firstName[0]} size={isMobile ? 'medium' : 'big'} />
        <div className="flex flex-col">
          <span className="font-nunito700 text-black text-xs md:text-sm">
            {firstName} {lastName}
          </span>
          <span className="font-nunito300 text-grey-500 text-xxs md:text-xs">
            {email}
          </span>
        </div>
      </div>
      <Button
        onClick={handleLogout}
        variant="secondary"
        className="w-full"
        size="extraSmall"
      >
        Logout
      </Button>
    </div>
  );
};
